/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

// images references in the manifest
import "../../assets/icon-16.png";
import "../../assets/icon-32.png";
import "../../assets/icon-80.png";

/* global console, document, Excel, Office */

Office.onReady(info => {
  if (info.host === Office.HostType.Excel) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("run").onclick = run;
    document.getElementById("clear").onclick = clear;
  }
});

export async function run() {
  try {
      Excel.run(async function (context) {
        var main = context.workbook.worksheets.getItem("Proposed Design");
        var vsc = context.workbook.worksheets.getItem("VSC");
        var apsh = context.workbook.worksheets.getItem("APSH");
        var nsl = context.workbook.worksheets.getItem("NSL");

        main.getRange("A4:A5007").copyFrom(vsc.getRange("A3:A5000"));
        main.getRange("B4:B5007").copyFrom(vsc.getRange("D3:D5000"));

        main.getRange("D4:E5007").copyFrom(vsc.getRange("E3:F5000"));

        main.getRange("H4:I5007").copyFrom(apsh.getRange("F3:G5003"));
        main.getRange("L4:M5007").copyFrom(apsh.getRange("J3:K5003"));

        main.getRange("P4:U5007").copyFrom(nsl.getRange("B3:G5003"));

        var range = main.getRange("D4:E5007");
        var range1 = main.getRange("S4:U5007");
        range.load("numberFormat");
        range1.load("numberFormat");

        var orientations = vsc.getRange("I3:I5007");
        orientations.load("values");

        var orientationRange = main.getRange("C4:C5008");
        orientationRange.load("values");
        
        await context.sync();

        range.numberFormat = "#.00";
        range1.numberFormat = "#.00";

        for (let i = 0; i < orientations.values.length; i++) {
          for (let j = 0; j < orientations.values[i].length; j++) {
            let number = orientations.values[i][j].split("°")[0];

            if (number !== "") {
              orientations.values[i][j] = degToCompass(number);
            }
          }
        }

        var orientationRange = main.getRange("C4:C5008");
        orientationRange.load("values");

        await context.sync();

        console.log(orientationRange.values);
        console.log(orientations.values);

        orientationRange.values = orientations.values;
                        
        return context.sync();
      });
  } catch (error) {
    console.error(error);
  }
}

function degToCompass(num) {
  let val = parseInt((num/45) + 0.5)
  let arr=["North","North East","East","South East","South","South West","West","North West"]
  return arr[(val % 8)]
}

export async function clear() {
  try {
      Excel.run(function (context) {
        var main = context.workbook.worksheets.getItem("Proposed Design");

        main.getRange("A4:E5007").clear();
        main.getRange("H4:I5007").clear();
        main.getRange("L4:M5007").clear();
        main.getRange("P4:U5007").clear();
    
        return context.sync();
      });
  } catch (error) {
    console.error(error);
  }
}
